import { colors } from '@noths/polaris-client-ribbons-design-system';
import { fontSize, mediaQuery, minBreakpoints, pxToRem, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import {
  ICON_BUTTON__BUTTON_CLASS,
  ICON_BUTTON__ICON_CLASS,
} from 'src/components/atoms/IconButton';
import {
  ACCORDION__HEADING_CLASS,
  ACCORDION__TITLE_CLASS,
} from 'src/components/molecules/Accordion';

const { text, spacing } = theme;

export const DELIVERY_SUMMARY_ID = 'delivery-summary';

export const deliveryArea = css`
  padding: ${pxToRem(35)} 0;
  grid-column: span 12;
  border-bottom: ${pxToRem(1)} solid ${colors.neutralLight};
  border-top: ${pxToRem(1)} solid ${colors.neutralLight};

  ${mediaQuery(
    { min: minBreakpoints.LARGE },
    css`
      grid-column: 2 / -2;
    `,
  )}

  .${ACCORDION__TITLE_CLASS} {
    ${fontSize(text.md.SMALL)};
    font-weight: 600;
  }

  .${ACCORDION__HEADING_CLASS}, .${ICON_BUTTON__BUTTON_CLASS} {
    width: 100%;
  }

  .${ICON_BUTTON__BUTTON_CLASS} {
    justify-content: space-between;
    align-items: center;

    .${ICON_BUTTON__ICON_CLASS} {
      margin: 0;
      align-self: auto;
    }
  }
`;

export const deliveryAreaSection = css`
  grid-column: span 12;

  ${mediaQuery(
    { min: minBreakpoints.MEDIUM },
    css`
      grid-column: span 6;
    `,
  )};
`;

export const heading = css`
  ${fontSize(text.sm.SMALL)};
  margin-top: ${pxToRem(spacing.xxl)};
  margin-bottom: ${pxToRem(spacing.lg)};

  &:first-child {
    margin-top: 0;
  }
`;
